import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { EventParticipation } from '../models/Event'
import { PARTICIPATIONS_URL } from '../utils/urls'

const fetchEventParticipations = (params: TableParams) =>
  SBAPI.FetchPaginated<EventParticipation[]>(`${PARTICIPATIONS_URL}`, params)

const fetchEventParticipationById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<EventParticipation>(`${PARTICIPATIONS_URL}/${id}`, params)

const checkIn = (participationId: number) =>
  SBAPI.Post(`${PARTICIPATIONS_URL}/${participationId}/checkin`, {})

const updateEventParticipation = (participation: EventParticipation) =>
  SBAPI.Put(`${PARTICIPATIONS_URL}/${participation.id}`, participation)

const deleteEventParticipation = (participationId: number) =>
  SBAPI.Delete(`${PARTICIPATIONS_URL}/${participationId}`)

export {
  checkIn,
  deleteEventParticipation,
  fetchEventParticipationById,
  fetchEventParticipations,
  updateEventParticipation,
}
